import React from 'react';
import { X, MapPin, Calendar, Clock, CheckCircle, Camera, ClipboardList, Home, Bath, BedDouble, AlertCircle } from 'lucide-react';
interface JobDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  job: any; // Using any for flexibility with OpportunityItem
}
export function JobDetailModal({
  isOpen,
  onClose,
  job
}: JobDetailModalProps) {
  if (!isOpen || !job) return null;
  return <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-969">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col animate-in zoom-in-95 duration-200" data-id="element-970">
        {/* Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-start" data-id="element-971">
          <div data-id="element-972">
            <div className="flex items-center gap-2 mb-2" data-id="element-973">
              <span className="px-2.5 py-0.5 rounded-full bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-wider" data-id="element-974">
                {job.serviceType || 'Pulizia Standard'}
              </span>
              {job.urgency === 'Alta' && <span className="px-2.5 py-0.5 rounded-full bg-red-50 text-red-700 text-xs font-bold uppercase tracking-wider flex items-center gap-1" data-id="element-975">
                  <AlertCircle size={10} data-id="element-976" /> Urgente
                </span>}
            </div>
            <h2 className="text-2xl font-bold text-navy mb-1" data-id="element-977">{job.address}</h2>
            <div className="flex items-center gap-2 text-gray-500 text-sm" data-id="element-978">
              <MapPin size={14} data-id="element-979" />
              <span data-id="element-980">Roma, RM</span>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-981">
            <X size={20} className="text-gray-400" data-id="element-982" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-983">
          {/* Key Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-984">
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-985">
              <div className="flex items-center gap-2 text-gray-400 mb-1" data-id="element-986">
                <Home size={16} data-id="element-987" />
                <span className="text-xs font-medium uppercase" data-id="element-988">
                  Superficie
                </span>
              </div>
              <p className="text-xl font-bold text-navy" data-id="element-989">{job.sqm} mq</p>
            </div>
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-990">
              <div className="flex items-center gap-2 text-gray-400 mb-1" data-id="element-991">
                <BedDouble size={16} data-id="element-992" />
                <span className="text-xs font-medium uppercase" data-id="element-993">Camere</span>
              </div>
              <p className="text-xl font-bold text-navy" data-id="element-994">2</p>
            </div>
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-995">
              <div className="flex items-center gap-2 text-gray-400 mb-1" data-id="element-996">
                <Bath size={16} data-id="element-997" />
                <span className="text-xs font-medium uppercase" data-id="element-998">Bagni</span>
              </div>
              <p className="text-xl font-bold text-navy" data-id="element-999">1</p>
            </div>
            <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-1000">
              <div className="flex items-center gap-2 text-gray-400 mb-1" data-id="element-1001">
                <Clock size={16} data-id="element-1002" />
                <span className="text-xs font-medium uppercase" data-id="element-1003">
                  Durata Est.
                </span>
              </div>
              <p className="text-xl font-bold text-navy" data-id="element-1004">2h 30m</p>
            </div>
          </div>

          {/* Checklist Preview */}
          <div className="mb-8" data-id="element-1005">
            <h3 className="text-sm font-bold text-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-1006">
              <ClipboardList size={16} className="text-teal-deep" data-id="element-1007" />
              Checklist Attività
            </h3>
            <div className="space-y-3" data-id="element-1008">
              {['Pulizia pavimenti e superfici', 'Sanificazione bagno', 'Cambio biancheria letto', 'Pulizia cucina e stoviglie', 'Controllo amenities'].map((item, i) => <div key={i} className="flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors" data-id="element-1009">
                  <div className="w-5 h-5 rounded-full border-2 border-gray-300 flex items-center justify-center" data-id="element-1010"></div>
                  <span className="text-gray-600 text-sm" data-id="element-1011">{item}</span>
                </div>)}
            </div>
          </div>

          {/* Photos */}
          <div data-id="element-1012">
            <h3 className="text-sm font-bold text-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-1013">
              <Camera size={16} className="text-teal-deep" data-id="element-1014" />
              Foto Richieste (3)
            </h3>
            <div className="grid grid-cols-3 gap-4" data-id="element-1015">
              {[1, 2, 3].map(i => <div key={i} className="aspect-video bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-400 gap-2 hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-1016">
                  <Camera size={24} data-id="element-1017" />
                  <span className="text-xs font-medium" data-id="element-1018">Foto {i}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end gap-3" data-id="element-1019">
          <button onClick={onClose} className="px-6 py-2.5 rounded-lg border border-gray-200 text-gray-600 font-medium hover:bg-white transition-colors" data-id="element-1020">
            Chiudi
          </button>
        </div>
      </div>
    </div>;
}